import { render, staticRenderFns } from "./ListaAdiantamentos.vue?vue&type=template&id=fdd225f8&"
import script from "./ListaAdiantamentos.vue?vue&type=script&lang=js&"
export * from "./ListaAdiantamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports